import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import { Table } from 'core';
import { Label } from 'core/components/label';
import NoResults from '../no-results';
import Row from './row';
import Header from './header';
import useStyles from './customer-results.styles';

const CustomersResults = ({
  loading,
  hits,
  totalHits,
  page,
  onPageChange,
  columnsToUse,
  showTitle,
  useLink,
  selectFieldName,
  mode,
  rowClickHandler,
  error,
  noDataMessage
}) => {
  const classes = useStyles({ mode });

  return (
    <>
      {showTitle && (
        <Label type="subtitle" style={{ marginBottom: 16 }}>
          Members
        </Label>
      )}
      <Paper className={classes.resultsContainer}>
        {Boolean(loading || hits.length) && (
          <Table
            selfContained={false}
            loading={loading}
            paginationEnabled
            count={totalHits}
            rowsPerPage={hits.length}
            currentPage={page}
            onPageChange={(_, page) => onPageChange(page)}
            header={<Header columnsToUse={columnsToUse} />}
            body={
              Boolean(hits && hits.length) &&
              hits.map((hit, ind) => (
                <Row
                  key={`hit-${ind}`}
                  hit={hit}
                  useLink={useLink}
                  columnsToUse={columnsToUse}
                  selectFieldName={selectFieldName}
                  onClick={rowClickHandler}
                />
              ))
            }
          />
        )}
        {Boolean(!loading && hits.length === 0) && <NoResults error={error} message={noDataMessage || undefined} />}
      </Paper>
    </>
  );
};

CustomersResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  hits: PropTypes.array,
  totalHits: PropTypes.number,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  rowClickHandler: PropTypes.func,
  columnsToUse: PropTypes.arrayOf(
    PropTypes.oneOf(['select', 'id', 'fname', 'lname', 'address', 'city', 'state', 'zip', 'phone', 'created'])
  ),
  showTitle: PropTypes.bool,
  useLink: PropTypes.bool,
  mode: PropTypes.string,
  selectFieldName: PropTypes.string,
  noDataMessage: PropTypes.string,
  error: PropTypes.object
};

CustomersResults.defaultProps = {
  hits: [],
  page: 1,
  onPageChange: null,
  totalHits: 0,
  rowClickHandler: null,
  columnsToUse: ['id', 'fname', 'lname', 'address', 'city', 'state', 'zip', 'created'],
  showTitle: true,
  useLink: false,
  mode: '',
  selectFieldName: null,
  noDataMessage: null
};

export default memo(CustomersResults);
